import api from "../apiClient";

// Tenant Config Inference — read proposals, confirm one field at a time.
// The confirm echoes base_fingerprint so a stale write is rejected server-side.

export const getSetupProposals = () =>
  api.get("/setup/proposals/").then((r) => r.data);

export const confirmSetupField = ({ field, value, baseFingerprint, source = "inferred" }) =>
  api
    .post("/setup/confirm/", {
      field,
      value,
      base_fingerprint: baseFingerprint,
      source,
    })
    .then((r) => r.data);

// Model-backed fields (FAQ, service descriptions) are NOT computed in the
// proposals GET — reading every page through the model would hang the page.
// The card offers a Generate button that calls this, then confirms as usual.
export const generateSetupField = (field) =>
  api.post("/setup/generate/", { field }).then((r) => r.data);
